'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _utils = require('../../../core/utils');

var _utils2 = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils2.getLog)('[ProductTimeWrapper]');

var WinresReservationTimeWrapperController = function () {
    function WinresReservationTimeWrapperController($scope, productService, localizationService, cancelService, discountService, $q, $filter) {
        _classCallCheck(this, WinresReservationTimeWrapperController);

        this.$scope = $scope;
        this.productService = productService;
        this.localizationService = localizationService;
        this.cancelService = cancelService;
        this.discountService = discountService;
        this.$q = $q;
        this.$filter = $filter;

        // Currently selected begin and end date in calendar.
        this.dateRange = null;

        // Reservable, non-reservable and forbidden dates.
        this.daterangeDates = [];

        this.selectedAmount = null;
        this.productAmounts = [];

        this.selectedDuration = null;
        this.productDurations = [];

        this.selectedTimeSlot = null;
        this.productTimeSlots = [];

        this.dayBeginTime = null;
        this.dayEndTime = null;

        // this.showTimeSlots = false;
        this.disableAddToCart = true;

        // Dates and times as moment.
        this.selectedBeginDate = null;
        this.selectedEndDate = null;
        this.selectedBeginTime = null;
        this.selectedEndTime = null;

        // Current destination product.
        this.destinationProduct = null;

        // Product that is reservable by current criteria.
        this.reservableProduct = null;

        // Search existing product in shopping cart by this product.
        this.searchProduct = null;

        // Reservability info.
        this.notReservable = null;
        this.priceNote = '';

        // Stored availability info.
        this.availabilities = null;
        this.defaultAvailabilities = null;
        this.defaultConditions = null;

        this.loadingPromise = null;

        this.state = 'waiting';
    }

    _createClass(WinresReservationTimeWrapperController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.data = this.winresReservationContext.getContext();

            this.initDateRange();

            this.$scope.$watch(function () {
                return _this.data.DestinationCode;
            }, function (destinationCode) {
                if (destinationCode) {
                    var wrc = _this.winresReservationContext;

                    // Get current destination in kohdesivu.
                    _this.fetchProduct(destinationCode, wrc.Params.ProductCode);
                } else {
                    _this.state = 'error';
                }
            });

            // Watch changes is shopping cart product list.
            this.$scope.$watchCollection(function () {
                return _this.data.Products;
            }, function () {
                if (_this.defaultAvailabilities != null) {
                    // Update free places in options.
                    _this.updateOptions(_.cloneDeep(_this.defaultAvailabilities), _.cloneDeep(_this.defaultConditions));
                }
            });
        }
    }, {
        key: 'initDateRange',
        value: function initDateRange() {
            var wrc = this.winresReservationContext;

            this.daterange = {
                startDate: (0, _moment2.default)(wrc.Params.StartDate),
                endDate: (0, _moment2.default)(wrc.Params.StartDate)
            };
        }
    }, {
        key: 'fetchProduct',
        value: function fetchProduct(destinationCode, productCode) {
            var _this2 = this;

            this.productService.getReservableProduct(destinationCode, productCode, this.localizationService.getLanguage(), 1, true).then(function (product) {
                // First product in kohdesivu destination.
                _this2.destinationProduct = product;

                log('Destination product:', _this2.destinationProduct);

                _this2.loadCalendar();
            });
        }
    }, {
        key: 'loadCalendar',
        value: function loadCalendar() {
            var _this3 = this;

            this.state = 'loading';

            var product = this.destinationProduct;

            var capacityRequest = this.productService.getCapacityCalendar(product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode);

            this.loadingPromise = capacityRequest;

            capacityRequest.then(function (productCapacities) {
                log('Capacities:', productCapacities);

                // Reservable, non-reservable and forbidden dates in calendar.
                _this3.daterangeDates = productCapacities;

                // Watch calendar date selection.
                _this3.watchCalendar();

                _this3.state = 'ready';
            }, function (error) {
                _this3.state = 'error';
            });
        }
    }, {
        key: 'watchCalendar',
        value: function watchCalendar() {
            var _this4 = this;

            if (this.dateWatch !== undefined) {
                // Cancel date watch.
                this.dateWatch();
            }

            var wrc = this.winresReservationContext;

            this.dateWatch = this.$scope.$watchGroup([function () {
                return wrc.Params.StartDate;
            }, function () {
                return wrc.Params.EndDate;
            }, function () {
                return _this4.daterange;
            }], function () {
                _this4.dateChanged();
            }, true);
        }
    }, {
        key: 'dateChanged',
        value: function dateChanged() {
            this.updateDateAndTime();
            this.fetchReservableProduct();
        }
    }, {
        key: 'updateDateAndTime',
        value: function updateDateAndTime() {
            var wrc = this.winresReservationContext;

            // Get begin date from url or calendar.
            var selectedBeginDate = this.daterange.startDate ? wrc.Params.StartDate // Begin date in url.
            : (0, _utils.formatISODate)(this.daterange); // Begin date in calendar.

            if (this.selectedTimeSlot != null && this.selectedTimeSlot.beginTime != null) {
                // Selected calendar date + selected begin time.
                this.selectedBeginDate = (0, _moment2.default)(selectedBeginDate + 'T' + this.selectedTimeSlot.beginTime);
            } else {
                // Selected calendar date.
                this.selectedBeginDate = (0, _moment2.default)(selectedBeginDate);
            }

            if (this.selectedDuration != null) {
                // Selected calendar date + selected begin time + selected duration in minutes.
                this.selectedEndDate = this.selectedBeginDate.clone().add(this.selectedDuration.durationMinutes, 'minutes');
            }

            if (this.selectedTimeSlot != null && this.selectedTimeSlot.beginTime != null) {
                this.selectedBeginTime = (0, _moment2.default)(this.selectedTimeSlot.beginTime, 'HH:mm');
                this.selectedEndTime = (0, _moment2.default)(this.selectedTimeSlot.endTime, 'HH:mm');
            }
        }
    }, {
        key: 'fetchReservableProduct',
        value: function fetchReservableProduct() {
            var _this5 = this;

            this.resetOptions();

            this.disableAddToCart = true;
            this.reservableProduct = null;

            this.notReservable = null;
            this.priceNote = '';

            var params = {
                DestinationCode: this.destinationProduct.DestinationInfo.DestinationCode,
                ProductCode: this.destinationProduct.DestinationInfo.ProductCode,
                StartDate: (0, _utils.formatISODate)(this.selectedBeginDate),
                EndDate: (0, _utils.formatISODate)(this.selectedBeginDate.clone().add(1, 'days')), // Add 1 day temporarily.
                NumAdults: this.data.NumAdults,
                NumChildren: this.data.NumChildren,
                NumInfants: this.data.NumInfants,
                Flags: ["K1ExtraAllMatchedPrices"],
                MinCapacity: 1,
                DiscountCode: this.discountService.getDiscountCodeFromLocalStorage()
            };

            var language = this.localizationService.getLanguage();

            var reservableProductRequest = this.productService.getReservableProductOrReasonWhyNotReservable(params, language);

            this.loadingPromise = reservableProductRequest;

            if (this.pending) {
                this.cancelService.cancel(this.pending);
            }

            this.pending = this.loadingPromise;

            this.pending.then(function (reservableProduct) {
                if (reservableProduct.NotReservable) {
                    log('Product is not reservable. Reason:', reservableProduct.NotReservable.Reason);
                    log('Full nonreservability info:', reservableProduct.NotReservable);

                    // Reason contains the reason the product is not available.
                    // Depending on the reason, other fields like PriceNote or
                    // MinimumDate may be set.
                    //
                    // Currently possible reasons are:
                    // - PriceNotFound - No price
                    // - PriceMinLength - Length of reservation is too short (P1/2/3).
                    //                    MinimumDays is set to shortest allowed length.
                    // - PriceStartWeekday - Start day is not an allowed weekday (P3)
                    // - PriceEndWeekday - End day is not an allowed weekday (P3)
                    // - PriceUnspecified - Pricing failed for an unspecified reason.
                    //                      PriceNote may contain extra info.
                    // - CapacityNoCapacityObject - No capacity row in database
                    // - CapacityNoCapacity - Sold out
                    // - CapacityClosingDate - The closing date has come.
                    //                         MinimumDate is set to next available date.
                    // - CapacityUnspecified - Capacity check failed for an unspecified reason.
                    _this5.notReservable = reservableProduct.NotReservable;
                    _this5.priceNote = reservableProduct.NotReservable.PriceNote;
                }

                _this5.reservableProduct = reservableProduct.Product;

                _this5.updateSearchProduct();
                _this5.updateAddToCartDisabledState();

                log('Reservable product:', _this5.reservableProduct);

                if (reservableProduct != null && reservableProduct.Product != null) {
                    // Data layer event after retrieving product.
                    _this5.winresReservationContext.dataLayerEvent('onLoadProduct', reservableProduct.Product);
                }

                if (reservableProduct != null && reservableProduct.Product != null && _this5.notReservable == null) {
                    var timeSlotRequest = _this5.productService.getTimeSlots(params.DestinationCode, params.ProductCode, params.StartDate);

                    _this5.loadingPromise = timeSlotRequest;
                    _this5.pending = _this5.loadingPromise;

                    _this5.pending.then(function (productTimeSlots) {
                        if (productTimeSlots != null) {
                            // Store availability info for later use.
                            _this5.defaultAvailabilities = _.cloneDeep(productTimeSlots.Availabilities);
                            _this5.defaultConditions = _.cloneDeep(productTimeSlots.Conditions);

                            // Update amounts, durations and time slots. 
                            _this5.updateOptions(productTimeSlots.Availabilities, productTimeSlots.Conditions);
                        }
                    }, function () {
                        // Show error.
                        _this5.notReservable = true;
                    });
                }
            }, function () {
                // Show error.
                _this5.notReservable = true;
            });;
        }
    }, {
        key: 'resetOptions',
        value: function resetOptions() {
            this.selectedAmount = null;
            this.productAmounts = [];

            this.selectedDuration = null;
            this.productDurations = [];

            this.selectedTimeSlot = null;
            this.productTimeSlots = [];

            this.dayBeginTime = null;
            this.dayEndTime = null;
        }
    }, {
        key: 'updateOptions',
        value: function updateOptions(availabilities, conditions) {
            if (this.searchProduct != null) {
                // Reduce free places by product lines.
                this.modifyAvailabilities(availabilities, conditions);
            }

            // Availabilities to use in options.
            this.availabilities = availabilities;

            // Day begin and end time for time slot select title.
            this.dayBeginTime = conditions.DayBeginTime;
            this.dayEndTime = conditions.DayEndTime;

            // Update options using this.availabilities and select first options.
            this.updateAmounts();
            this.updateDurations();
            this.updateTimeSlots();

            // Watch amount, dates, duration and time slots.
            this.watchOptions();
        }
    }, {
        key: 'modifyAvailabilities',
        value: function modifyAvailabilities(availabilities) {
            var productLines = this.winresReservationContext.findProductLinesByProduct(this.searchProduct);

            // Reduce free places by product lines.
            _.each(availabilities, function (availability) {
                _.each(productLines, function (productLine) {
                    var productBeginTime = (0, _moment2.default)(productLine.Product.BeginTime, 'HH:mm');
                    var productEndTime = (0, _moment2.default)(productLine.Product.EndTime, 'HH:mm');
                    var availabilityBeginTime = (0, _moment2.default)(availability.BeginTime, 'HH:mm');
                    var availabilityEndTime = (0, _moment2.default)(availability.EndTime, 'HH:mm');

                    if (availabilityBeginTime >= productBeginTime && availabilityBeginTime < productEndTime || availabilityEndTime > productBeginTime && availabilityEndTime <= productEndTime || productBeginTime >= availabilityBeginTime && productBeginTime < availabilityEndTime || productEndTime > availabilityBeginTime && productEndTime <= availabilityEndTime) {
                        // Reduce free places if begin or end time is within product begin and end time.
                        availability.FreePlaces -= productLine.Amount;
                    }
                });
            });
        }
    }, {
        key: 'getProductAmounts',
        value: function getProductAmounts(availabilities) {
            // Simple array of numbers.
            // Use highest possible free places as max value.
            var freePlaces = _.map(availabilities, function (availability) {
                return availability.FreePlaces;
            });
            return _.range(_.max(freePlaces) + 1);
        }
    }, {
        key: 'getProductDurations',
        value: function getProductDurations(availabilities) {
            var _this6 = this;

            if (this.selectedAmount === null) {
                return [];
            }

            var durationsByAmount = _.filter(availabilities, function (availability) {
                return availability.FreePlaces >= _this6.selectedAmount;
            });

            var onlyHours = _.every(durationsByAmount, function (duration) {
                return duration.DurationMinutes % 60 == 0;
            });

            // Array of durations.
            var durations = _.sortBy(_.uniqBy(_.map(durationsByAmount, function (duration) {
                return {
                    'name': _this6.getDurationLabel(duration, onlyHours),
                    'durationMinutes': duration.DurationMinutes,
                    'price': duration.PriceAmount
                };
            }), 'durationMinutes'), 'durationMinutes');

            // Add first option.
            durations.unshift({
                'name': this.$filter('i18next')('time_slots.select_duration')
            });

            return durations;
        }
    }, {
        key: 'getDurationLabel',
        value: function getDurationLabel(duration, onlyHours) {
            var beginDate = (0, _moment2.default)().startOf('day');
            var endDate = beginDate.clone().add(duration.DurationMinutes, 'minutes');

            if (duration.PriceDurationMinutes !== null) {
                // Only hours or minutes.

                var minutes = endDate.minutes(); // Minutes in current hour.
                var hours = endDate.diff(beginDate, 'hours'); // Hour difference.

                if (minutes === 0 && hours === 0) {
                    // Skip.
                } else if (hours === 0) {
                    return endDate.format('m [min]'); // Minutes.
                } else if (onlyHours) {
                    return hours + ' h'; // Even hours.
                } else {
                    return hours + ' h ' + endDate.format('m [min]'); // Hour with minutes.
                }
            } else if (duration.PriceDurationDays !== null) {
                // Only days.

                var days = endDate.diff(beginDate, 'days') + 1; // Day difference.

                return days + (days === 1 ? this.$filter('i18next')('time_slots.day') : this.$filter('i18next')('time_slots.days'));
            }
        }
    }, {
        key: 'getProductTimeSlots',
        value: function getProductTimeSlots(availabilities) {
            var _this7 = this;

            if (this.selectedAmount === null || this.selectedDuration === null) {
                return [];
            }

            var timeSlotsByAmountAndDuration = _.filter(availabilities, function (availability) {
                return availability.FreePlaces >= _this7.selectedAmount && availability.DurationMinutes === _this7.selectedDuration.durationMinutes;
            });

            // Array of dates.
            var timeSlots = _.uniqBy(_.map(timeSlotsByAmountAndDuration, function (timeSlot) {
                return {
                    'name': timeSlot.BeginTime + ' - ' + timeSlot.EndTime,
                    'beginTime': timeSlot.BeginTime,
                    'endTime': timeSlot.EndTime,
                    'freePlaces': timeSlot.FreePlaces
                };
            }), 'beginTime');

            // Add first option.
            timeSlots.unshift({
                'name': this.$filter('i18next')('time_slots.select_time')
            });

            return timeSlots;
        }
    }, {
        key: 'watchOptions',
        value: function watchOptions() {
            var _this8 = this;

            if (this.amountWatch !== undefined && this.durationWatch !== undefined && this.timeSlotWatch !== undefined) {
                // Cancel watches.
                this.amountWatch();
                this.durationWatch();
                this.timeSlotWatch();
            }

            this.amountWatch = this.$scope.$watchGroup([function () {
                return _this8.selectedAmount;
            }], function () {
                _this8.amountChanged();
            }, true);

            this.durationWatch = this.$scope.$watchGroup([function () {
                return _this8.selectedDuration;
            }], function () {
                _this8.durationChanged();
            }, true);

            this.timeSlotWatch = this.$scope.$watch(function () {
                return _this8.selectedTimeSlot;
            }, function () {
                _this8.timeSlotChanged();
            }, true);
        }
    }, {
        key: 'amountChanged',
        value: function amountChanged() {
            // Update duration options.
            this.updateDurations();

            if (this.selectedAmount === this.productAmounts[0]) {
                // Select first duration when first amount is selected.
                this.selectedDuration = this.productDurations[0];
            }
        }
    }, {
        key: 'durationChanged',
        value: function durationChanged() {
            // Update time slots.
            this.updateTimeSlots();

            if (this.selectedDuration != null && this.selectedDuration.name === this.productDurations[0].name) {
                // Deselect time slot when first duration is selected.
                this.selectedTimeSlot = null;
            }

            this.updateDateAndTime();
            this.updateAddToCartDisabledState();
        }
    }, {
        key: 'timeSlotChanged',
        value: function timeSlotChanged() {
            this.updateDateAndTime();
            this.updateSearchProduct();
            this.updateAddToCartDisabledState();
        }

        // Update amount.

    }, {
        key: 'updateAmounts',
        value: function updateAmounts() {
            // Product amount options in product amount select.
            this.productAmounts = this.getProductAmounts(this.availabilities);

            // Select first amount.
            this.selectedAmount = this.productAmounts[0];
        }

        // Update durations by amount selection.

    }, {
        key: 'updateDurations',
        value: function updateDurations() {
            // Product duration options in product duration select.
            this.productDurations = this.getProductDurations(this.availabilities);

            // Select first duration.
            this.selectedDuration = this.productDurations[0];
        }

        // Update time slots by amount and duration selection.

    }, {
        key: 'updateTimeSlots',
        value: function updateTimeSlots() {
            // Product time options in product begin time select.
            this.productTimeSlots = this.getProductTimeSlots(this.availabilities);

            // Select first time slot.
            this.selectedTimeSlot = this.productTimeSlots[0];
        }
    }, {
        key: 'updateSearchProduct',
        value: function updateSearchProduct() {
            if (this.reservableProduct !== null) {
                var searchProduct = _.cloneDeep(this.reservableProduct);

                searchProduct.BeginDate = (0, _utils.formatISODate)(this.selectedBeginDate);
                searchProduct.EndDate = (0, _utils.formatISODate)(this.selectedEndDate);

                if (this.selectedBeginTime != null && this.selectedEndTime != null) {
                    searchProduct.BeginTime = this.selectedBeginTime.format('HH:mm');
                    searchProduct.EndTime = this.selectedEndTime.format('HH:mm');
                }

                // Search existing product in shopping cart by this product.
                this.searchProduct = searchProduct;
            }
        }
    }, {
        key: 'updateAddToCartDisabledState',
        value: function updateAddToCartDisabledState() {
            this.disableAddToCart = this.reservableProduct == null || this.selectedBeginDate == null || this.selectedTimeSlot == null || this.selectedTimeSlot.beginTime == null || this.notReservable != null;
        }
    }, {
        key: 'addToCart',
        value: function addToCart() {
            // Search product in shopping cart.
            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(this.searchProduct);

            if (!productLine.Amount) {
                productLine.Amount = 0;
            }

            if (!productLine.TotalPrice) {
                productLine.TotalPrice = 0;
            }

            var available = this.pickAvailable();

            productLine.Amount += this.selectedAmount;
            productLine.Product.Amount = productLine.Amount;

            var price = available.PriceAmount;
            productLine.TotalPrice = price * productLine.Amount;
            productLine.UnitPrice = price;

            productLine.Product.BeginDate = this.searchProduct.BeginDate;
            productLine.Product.EndDate = this.searchProduct.EndDate;

            productLine.Product.BeginTime = this.searchProduct.BeginTime;
            productLine.Product.EndTime = this.searchProduct.EndTime;

            // Reset options.
            this.resetOptions();

            if (this.defaultAvailabilities != null) {
                // Update free places in options.
                this.updateOptions(_.cloneDeep(this.defaultAvailabilities), _.cloneDeep(this.defaultConditions));
            }
        }
    }, {
        key: 'pickAvailable',
        value: function pickAvailable() {
            var _this9 = this;

            // Pick available by amount, duration and time slot.
            return _.find(this.availabilities, function (availability) {
                return availability.FreePlaces >= _this9.selectedAmount && availability.DurationMinutes === _this9.selectedDuration.durationMinutes && availability.BeginTime === _this9.selectedTimeSlot.beginTime;
            });
        }
    }, {
        key: 'getReservationText',
        value: function getReservationText() {
            if (this.reservableProduct == null || this.selectedBeginDate == null || this.selectedTimeSlot == null || this.selectedTimeSlot.beginTime == null || this.notReservable != null) {
                return '';
            }

            // Language for week name.
            _moment2.default.locale(this.localizationService.getLanguage());

            var beginTimeFormat = this.selectedBeginDate.format('HH:mm'); // 10:00
            var beginDateFormat = this.selectedBeginDate.format('dd DD.MM.'); // Mo 01.01.
            var endTimeFormat = this.selectedEndDate.format('HH:mm'); // 10:00
            var endDateFormat = this.selectedEndDate.format('dd DD.MM.'); // Mo 01.01.
            var isSameDay = beginDateFormat === endDateFormat;

            if (isSameDay === true) {
                return this.$filter('i18next')('time_slots.reservation_summary_same_day', {
                    beginTime: beginTimeFormat,
                    beginDate: beginDateFormat,
                    endTime: endTimeFormat
                });
            }

            // If end date occurs after begin date.
            return this.$filter('i18next')('time_slots.reservation_summary', {
                beginTime: beginTimeFormat,
                beginDate: beginDateFormat,
                endTime: endTimeFormat,
                endDate: endDateFormat
            });
        }
    }]);

    return WinresReservationTimeWrapperController;
}();

WinresReservationTimeWrapperController.$inject = ['$scope', 'productService', 'localizationService', 'cancelService', 'discountService', '$q', '$filter'];

_module3.default.component('winresReservationTimeWrapper', {
    template: require('./winresReservationTimeWrapper.html'),
    controller: WinresReservationTimeWrapperController,
    bindings: {},
    require: {
        winresReservationContext: '^^winresReservationContext'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationTimeWrapper/winresReservationTimeWrapper.js
// module id = 471
// module chunks = 2